export default "__VITE_ASSET__BDgMZZwD__"